<template>
	<div>
		<CRow>
			<CCol sm="12">
				<CCard>
					<CCardHeader> Déplacer les colis </CCardHeader>

					<CCardBody>
						<CRow>
							<CCol sm="4">
								<CInput
									label="Nombre d'étiquette à imprimer"
									placeholder="(vide=toute)"
									type="number"
									min="1"
									name="setLimit"
									v-model.number="setLimit" />
							</CCol>
						</CRow>
						<CRow>
							<CCol sm="4">
								<vc-date-picker
									mode="date"
									timezone="UTC"
									:masks="{ input: 'DD/MM/YYYY' }"
									v-model="sendingDate">
									<template v-slot="{ inputValue, inputEvents }">
										<CInput
											label="Changer la date d'envoi"
											type="text"
											name="sendingDate"
											:value="inputValue"
											v-on="inputEvents" />
									</template>
								</vc-date-picker>
							</CCol>
						</CRow>
						<CButton class="mb-3" :disabled="loading" @click.prevent="onSubmit()" color="success">
							<CSpinner v-show="loading" color="#fff" size="sm" />
							<span class="ml-2">Déplacer les colis</span>
							<CIcon class="ml-2" name="cil-tags" />
						</CButton>
						<GDataTableRemote
							ref="mainTable"
							:remote-url="`/api/order_items?parentOrder.status[]=order.paid&parentOrder.status[]=order.complete&parentOrder.status[]=order.admin_authorized&parentOrder.status[]=order.awaiting_delayed_payment&state=order_item.pending&shippingMethod[]=CHRONO13&shippingMethod[]=INT`"
							:fields="fields"
							:items-per-page="10"
							:default-filter-state="defaultFilterState"
							hover
							striped
							sorter
							columnFilter
							pagination>
							<template #receiverAddress.country-filter>
								<select
									class="form-control form-control-sm"
									@change="
										$refs.mainTable.columnFilterEvent(
											'receiverAddress.country',
											$event.target.value,
											'change'
										)
									">
									<option></option>
									<!-- Placeholder -->
									<option v-for="option in countriesOptions" :value="option.value">
										{{ option.label }}
									</option>
								</select>
							</template>

							<template #product-filter>
								<select
									class="form-control form-control-sm"
									@change="
										$refs.mainTable.columnFilterEvent(
											'product',
											$event.target.value,
											'change'
										)
									">
									<option></option>
									<!-- Placeholder -->
									<!--                                    <option v-for="option in productsOptions" :value="option.value">{{ option.label }}</option>-->
								</select>
							</template>

							<template #product="{ item }">
								<td>
									{{ item.product ? item.product.name : '' }}
								</td>
							</template>

							<template #receiverAddress.country="{ item }">
								<td>
									{{ item.receiverAddress ? item.receiverAddress.country.name : '' }}
								</td>
							</template>

							<template #parentOrder.concept="{ item }">
								<td>
									<CBadge :color="orderConceptColor[item.parentOrder.concept]">{{
										orderConceptTranslation[item.parentOrder.concept]
									}}</CBadge>
								</td>
							</template>

							<template #hasMessage="{ item }">
								<td v-if="item.hasMessage" class="text-center">
									<CIcon name="cil-check" style="color: green" />
								</td>
								<td v-if="!item.hasMessage" class="text-center">
									<CIcon name="cil-ban" style="color: red" />
								</td>
							</template>

							<template #exact_name="{ item }">
								<td>
									{{ item.name }}
								</td>
							</template>

							<template #actions="{ item }">
								<td class="text-center">
									<a
										class="text-center icon-space"
										href="#"
										@click.prevent="onSubmit('single', item.id)">
										<CIcon name="cil-tag" />
									</a>
								</td>
							</template>
						</GDataTableRemote>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
	</div>
</template>
<script>
	import GDataTableRemote from '../../../components/ghostlexly-components/GDataTableRemote';

	export default {
		components: { GDataTableRemote },
		data() {
			this.orderConceptOptions = [
				{ value: 'order.colipays', label: 'Colipays' },
				{ value: 'order.colikado', label: 'Colikado' },
				{ value: 'order.aupaysdesfleurs', label: 'Au pays des fleurs' },
			];

			return {
				quantity: null,
				fields: [
					{ key: 'reference', label: '#' },
					{ key: 'parentOrder.id', label: '# Commande' },
					{
						key: 'parentOrder.concept',
						label: 'Concept',
						type: 'select',
						filterSelectOptions: this.orderConceptOptions,
					},
					{
						key: 'exact_name',
						label: 'Type de colis',
						sorter: true,
						type: 'autocomplete',
						queryUrl: '/api/order_items?order[name]=asc',
						searchFieldName: 'name',
					},
					{
						key: 'hasMessage',
						label: 'Message dans le colis?',
						type: 'select',
						filterSelectOptions: [
							{ value: 0, label: 'Non' },
							{ value: 1, label: 'Oui' },
						],
					},
					{ key: 'shippingDate', label: "Date d'envoi", type: 'daterange' },
					{ key: 'receiverAddress.postalCode', label: 'Code postal', sorter: true },
					{ key: 'receiverAddress.country', label: 'Pays' },
					{ key: 'actions', filter: false },
				],
				defaultFilterState: {
					shippingDate: {
						start: this.$moment().format('YYYY-MM-DD'),
						end: this.$moment().format('YYYY-MM-DD'),
					},
				},
				orderConceptTranslation: {
					'order.colipays': 'Colipays',
					'order.colikado': 'Colikado',
					'order.aupaysdesfleurs': 'Au pays des fleurs',
				},
				orderConceptColor: {
					'order.colipays': 'warning',
					'order.colikado': 'danger',
					'order.aupaysdesfleurs': 'success',
				},
				loading: false,
				countries: [],
				countriesOptions: [],
				setLimit: 1,
				sendingDate: this.$moment().format('YYYY-MM-DD'),
			};
		},
		methods: {
			onSubmit: function (type, id) {
				let error,
					endpoint = null;

				this.loading = true;
				let searchQueries = new URLSearchParams();
				searchQueries.append('itemsPerPage', this.setLimit ? this.setLimit : '9999');
				searchQueries.append('parentOrder.status[]', 'order.paid');
				searchQueries.append('parentOrder.status[]', 'order.complete');
				searchQueries.append('parentOrder.status[]', 'order.admin_authorized');
				searchQueries.append('parentOrder.status[]', 'order.awaiting_delayed_payment');
				searchQueries.append('state', 'order_item.pending');

				// Columns search filters
				Object.entries(this.$refs.mainTable.columnFilterState).forEach(([key, value]) => {
					const columnFilter = String(value).toLowerCase();
					if (key === 'shippingDate' && columnFilter) {
						searchQueries.append(
							key + '[after]',
							this.$moment(value.start).format('YYYY-MM-DD HH:mm')
						);
						searchQueries.append(
							key + '[before]',
							this.$moment(value.end).format('YYYY-MM-DD HH:mm')
						);
					} else if (columnFilter && this.$refs.mainTable.rawColumnNames.includes(key)) {
						searchQueries.append(key, columnFilter);
					}
				});

				// Columns orderBy
				searchQueries.append('order[receiverAddress.postalCode]', 'asc');

				// Set new sending date
				searchQueries.append('sendingDate', this.$moment.utc(this.sendingDate).format('YYYY-MM-DD'));

				endpoint = '/api/order_items/move' + '?' + searchQueries.toString();
				error = 'Aucun colis restant pour ce jour';

				this.$axios
					.get(endpoint, {
						timeout: 3600000, // 1 hour
					})
					.then(res => {
						this.loading = false;
						this.$refs.mainTable.refresh();
					})
					.catch(err => {
						this.$refs.mainTable.refresh();
						this.loading = false;

						if (err.response.status === 404) {
							this.$toast.error(error);
						} else if (err.response.data['hydra:description'] != null) {
							this.$toast.error(err.response.data['hydra:description']);
						} else {
							this.$toast.error(
								'Un problème est survenu lors de la transmission des étiquettes.'
							);
						}
					});
			},
			loadCountries() {
				this.$axios
					.get('/api/countries?itemsPerPage=999')
					.then(res => {
						this.countries = res.data['hydra:member'];
						this.countriesOptions = res.data['hydra:member'].map(country => {
							return {
								value: country['id'],
								label: country.name,
							};
						});
					})
					.catch(err => {
						this.$toast.error(
							'Erreur lors du chargement des pays, veuillez contacter un administrateur'
						);
					});
			},
		},
		mounted() {
			this.loadCountries();
		},
	};
</script>

<style>
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.4s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
</style>
